import { esOperativoComercial } from "./getEdificiosOperativos";

// Fuente única del resumen "edificios operativos + en instalación / pantallas totales" de la red
// comercial pública (regla 10.1) — antes vivía inline en InventarioAvanzado. Función pura sobre un
// array de edificios ya cargado (mismo criterio que /inventario: quien la llama decide si pasa el
// listado completo o uno ya filtrado por UI, el cálculo no vuelve a pedir datos).
export const calcularResumenRedComercial = (edificios) => {
  const lista = edificios || [];
  const totalOperativos = lista.filter(esOperativoComercial).length;
  const totalInstalacion = lista.filter((e) => e.estado === "INSTALACIÓN").length;
  const totalPantallas = lista.reduce(
    (sum, e) => sum + (e.pantallas || 0) + (e.totems || 0) + (e.espera || 0) + (e.cowork || 0),
    0
  );
  return {
    totalOperativos,
    totalInstalacion,
    totalEdificios: totalOperativos + totalInstalacion,
    totalPantallas,
  };
};
